import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="relative">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
        <Icon name="search" size={20} className="text-muted-foreground" />
      </div>
      <Input
        type="search"
        placeholder="Search tasks by title, person, or category..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e?.target?.value)}
        className="pl-12"
      />
    </div>
  );
};

export default SearchBar;